module.exports = __webpack_public_path__ + "img/sy_3.ca74a76f.png";